<template>
  <div>
    <!-- 底部 -->
    <div class="foot">
      <!-- 进口商信息 -->
      <div class="address item">
        <!-- 进口商信息: -->
        <h6>
          {{ $t("message.importer") }}
          <!-- 选择地址 -->
          <el-select v-model="importerVal" placeholder="地址选择" filterable @change="setAddress($event, 'importer')"
            style="margin-left: 20px;width:150px;margin-right: 20px;" v-if="isImporterEdit">
            <el-option v-for="item in addressList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
          <!-- 历史进口商 -->
          <el-button type="warning" size="small" v-if="isImporterEdit"
            @click="historicalAddresses('历史进口商', 1)">历史进口商</el-button>
          <!-- 编辑修改 -->
          <el-button type="text" class="fr" @click="isImporterEdit = !isImporterEdit"
            v-if="!isImporterEdit && !Controls && detail.merge_type != '并单出货·子'">
            {{ $t("message.editAndModify") }}
          </el-button>
          <!-- 完成 -->
          <el-button type="text" class="fr" @click="addAddress('importer')" v-if="isImporterEdit">
            {{ $t("message.complete") }}
          </el-button>
        </h6>
        <!--会社： -->
        <div class="row">
          <div class="label">会社：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.company" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.company }}
          </div>
        </div>
        <div class="row">
          <div class="label">会社名（ローマ字）：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.company_roma" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.company_roma }}
          </div>
        </div>
        <!--郵便： -->
        <div class="row">
          <div class="label">郵便：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.zip_code" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.zip_code }}
          </div>
        </div>
        <!--住所： -->
        <div class="row row2">
          <div class="label">住所：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.address" type="textarea" onfocus="this.select()"></el-input>
          </div>
          <div class="value domicile" v-else>
            {{ importer.address }}
          </div>
        </div>
        <!--ローマ字： -->
        <div class="row">
          <div class="label">ローマ字：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.address_roma" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.address_roma }}
          </div>
        </div>
        <!--氏名： -->
        <div class="row">
          <div class="label">氏名：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.contacts" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.contacts }}
          </div>
        </div>
        <!--ローマ字： -->
        <div class="row">
          <div class="label">ローマ字：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.contacts_roma" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.contacts_roma }}
          </div>
        </div>
        <!--携帯番号： -->
        <div class="row">
          <div class="label">携帯番号：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.mobile" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.mobile }}
          </div>
        </div>
        <!--固定電話： -->
        <div class="row">
          <div class="label">固定電話：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.tel" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.tel }}
          </div>
        </div>
        <!--法人番号： -->
        <div class="row">
          <div class="label">法人番号：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.tax_no" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.tax_no }}
          </div>
        </div>
        <!--リアルタイム口座 -->
        <div class="row">
          <div class="label">リアルタイム口座：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.bank_no" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.bank_no }}
          </div>
        </div>
        <!--標準コード -->
        <div class="row">
          <div class="label">標準コード：</div>
          <div class="value" v-if="isImporterEdit">
            <el-input v-model="importer.standard_no" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ importer.standard_no }}
          </div>
        </div>
      </div>
      <!-- 收件人信息 -->
      <div class="address item">
        <!-- 收件人信息: -->
        <h6>
          {{ $t("message.receive") }}
          <!-- 选择地址 -->
          <el-select v-model="receiverVal" placeholder="地址选择" filterable @change="setAddress($event, 'receiver')"
            style="margin-left: 20px;width:150px;margin-right: 20px;" v-if="isReceiverEdit">
            <el-option v-for="item in addressList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
          <!-- 历史收件人 -->
          <el-button type="warning" size="small" v-if="isReceiverEdit"
            @click="historicalAddresses('历史收件人', 2)">历史收件人</el-button>
          <!-- 编辑修改 -->
          <el-button type="text" size="mini" class="fr" @click="isReceiverEdit = !isReceiverEdit"
            v-if="!isReceiverEdit && !Controls && detail.merge_type != '并单出货·子'">{{ $t("message.editAndModify")
            }}</el-button>
          <!-- 从仓库选择地址 -->
          <el-button type="primary" size="mini" class="fr" @click="$refs.thirdParty.dialogVisible = true"
            v-if="!isReceiverEdit && !Controls && detail.merge_type != '并单出货·子'"
            style="margin-right: 20px;">从仓库选择地址</el-button>
          <!-- 完成 -->
          <el-button type="text" size="mini" class="fr" @click="addAddress('receive')" v-if="isReceiverEdit">
            {{ $t("message.complete") }}
          </el-button>
        </h6>
        <!--会社： -->
        <div class="row">
          <div class="label">会社：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.company" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.company }}
          </div>
        </div>
        <div class="row">
          <div class="label">会社名（ローマ字）：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.company_roma" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.company_roma }}
          </div>
        </div>
        <!--郵便： -->
        <div class="row">
          <div class="label">郵便：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.zip_code" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.zip_code }}
          </div>
        </div>
        <!--住所： -->
        <div class="row row2">
          <div class="label">住所：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.address" type="textarea" onfocus="this.select()"></el-input>
          </div>
          <div class="value domicile" v-else>
            {{ receiver.address }}
          </div>
        </div>
        <!--ローマ字： -->
        <div class="row">
          <div class="label">ローマ字：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.address_roma" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.address_roma }}
          </div>
        </div>
        <!--氏名： -->
        <div class="row">
          <div class="label">氏名：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.contacts" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.contacts }}
          </div>
        </div>
        <!--ローマ字： -->
        <div class="row">
          <div class="label">ローマ字：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.contacts_roma" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.contacts_roma }}
          </div>
        </div>
        <!--携帯番号： -->
        <div class="row">
          <div class="label">携帯番号：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.mobile" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.mobile }}
          </div>
        </div>
        <!--固定電話： -->
        <div class="row">
          <div class="label">固定電話：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.tel" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.tel }}
          </div>
        </div>
        <!--法人番号： -->
        <div class="row">
          <div class="label">法人番号：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.tax_no" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.tax_no }}
          </div>
        </div>
        <!--リアルタイム口座 -->
        <div class="row">
          <div class="label">リアルタイム口座：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.bank_no" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.bank_no }}
          </div>
        </div>
        <!--標準コード -->
        <div class="row">
          <div class="label">標準コード：</div>
          <div class="value" v-if="isReceiverEdit">
            <el-input v-model="receiver.standard_no" onfocus="this.select()"></el-input>
          </div>
          <div class="value" v-else>
            {{ receiver.standard_no }}
          </div>
        </div>
      </div>
      <!-- 费用 -->
      <div class="item">
        <div class="expense">
          <!-- 国际费用 -->
          <h6>{{ $t("message.internationalFees") }}:</h6>
          <!-- 汇率 -->
          <div class="row">
            <div class="label">{{ $t("message.rate") }}:</div>
            <div class="value">
              1元={{ detail.exchange_rate && detail.exchange_rate != 0 ? detail.exchange_rate : rate }}
              円
            </div>
          </div>
          <!-- 客户指定发送方式 -->
          <div class="row Select">
            <div class="label">
              {{ $t("message.theCustomerSpecifiesTheSendingMode") }}:
            </div>
            <div class="value" v-if="detail.logistics">
              {{ detail.logistics.name }}
              <!-- <el-select v-model="detail.logistics.id" placeholder="地址选择" filterable @change="updatePorderLogistics"
                :disabled="status != 22">
                <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select> -->
            </div>
          </div>
          <!-- 国际运费(元) -->
          <div class="row" v-if="status > 21">
            <div class="label">
              {{ $t("message.internationalFreight") }}(元):
            </div>
            <div class="value">
              <!-- manualQuotation && -->
              <!-- <el-input v-if="status == 22" v-model="detail.logistics_price" type="number"></el-input> -->
              <span> {{ detail.logistics_price }}</span>
            </div>
          </div>
          <!-- 国际运费(円) -->
          <div class="row" v-if="status > 21">
            <div class="label">
              {{ $t("message.internationalFreight") }}(円)【<a href="https://www.rakumart.com/internationalLogistics"
                target="_blank" rel="noopener noreferrer">
                <el-button type="text">URL</el-button></a>】:
            </div>
            <div class="value">
              {{ (detail.logistics_price * (detail.exchange_rate ? detail.exchange_rate : rate)).toFixed(0) }}
            </div>
          </div>
          <!-- 其他费用 -->
          <div class="row" v-if="status > 21">
            <div class="label">
              {{ $t("message.otherFees") }}(元)【<el-button type="text" @click="edit_other_price">
                {{ $t("message.detail") }}</el-button>】:
            </div>
            <div class="value">
              <i class="el-icon-edit-outline" @click="edit_other_price" v-if="status == 22 && isAuth(250)"></i>
              {{ detail.other_price }}
            </div>
          </div>
          <!-- 其他费用 -->
          <div class="row" v-if="status > 21">
            <div class="label">{{ $t("message.otherFees") }}(円):</div>
            <div class="value">
              <!-- <i class="el-icon-edit-outline" @click="edit_other_price" v-if="status == 22"></i> -->
              {{ (detail.other_price * (detail.exchange_rate ? detail.exchange_rate : rate)).toFixed(0) }}
            </div>
          </div>
          <!-- 通关手续费 円 -->
          <div class="row" v-if="status > 21">
            <div class="label">{{ $t("message.customsClearanceFee") }}(円)
              【<el-popover placement="left" title="通关手续费明细" width="250" trigger="click">
                <el-table :data="detail.service_fee_list">
                  <el-table-column width="120" property="name" label="收费物流" align="center"></el-table-column>
                  <el-table-column width="120" property="fee" label="費用.円" align="center"></el-table-column>
                </el-table>
                <el-button type="text" slot="reference">
                  {{ $t("message.detail") }}
                </el-button>
              </el-popover>】
              :
            </div>
            <div class="value">
              <!-- <i class="el-icon-edit-outline" @click="edit_other_price" v-if="status == 22"></i> -->
              {{ detail.service_fee }}
            </div>
          </div>
        </div>
        <!-- 贴标标签数 -->
        <div class="tag">
          <h6>{{ $t("message.numOfLabels") }}:</h6>
          <!-- 贴标填写数 -->
          <div class="row">
            <div class="label">{{ $t("message.numberOfLabelEntries") }}:</div>
            <div class="value">
              <!-- 修改 -->
              <el-input v-model="detail.fba_fill_num" v-if="status == 21" type="number" onfocus="this.select()"
                @blur="fbaFillNum"></el-input>
              <span v-else>
                {{ detail.fba_fill_num }}
              </span>
            </div>
          </div>
          <!-- 预计标签数： -->
          <div class="row">
            <div class="label">{{ $t("message.expectedNumberOfTags") }}:</div>
            <div class="value">{{ tag_num }}</div>
          </div>
          <!-- 实际标签数： -->
          <div class="row">
            <div class="label">{{ $t("message.actualNumberOfTags") }}:</div>
            <div class="value">
              <!-- 修改 -->
              <el-input v-model="detail.fba_complete_num" v-if="status == 22 || isAuth(481)" type="number"
                @blur="updateFbaCompleteNum" onfocus="this.select()"></el-input>
              <span v-else>
                {{ detail.fba_complete_num }}
              </span>
              <!-- 修改 -->
              <!-- <el-button type="primary" class="fr" v-if="status > 22 && isAuth(481)" style="margin-left: 20px;"
                @click="updatePorderRealTagPrint">{{
                  $t("message.edit")
                }}</el-button> -->
            </div>
          </div>
          <!-- 标签匹配数: -->
          <div class="row">
            <div class="label">{{ $t("message.tagMatchingNumber") }}:</div>
            <div class="value">{{ match_num }}</div>
          </div>
          <!-- 品名编辑 -->
          <div class="row">
            <div class="label">{{ $t("message.titleEditor") }}:</div>
            <div class="value">
              <router-link :to="'/orderMaterialPreview?porder_sn=' + porder_sn" target="_blank" v-if="isAuth(251)">
                {{ detail.material }}</router-link>
              <span v-else>{{ detail.material }}</span>
            </div>
          </div>
          <!-- 配送单装箱明细下载： -->
          <div class="row" v-if="status > 21">
            <div class="label">
              {{ $t("message.shippingListPackingDetailsLook") }}:
            </div>
            <div class="value">
              <router-link :to="'/packingDetails?porder_sn=' + porder_sn" target="_blank">
                <img src="@/assets/img/attachment.svg" alt="" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 客户备注  -->
      <div class="item remarkItem">
        <div class="remark" v-if="detail.porder_remark">
          <!-- 客户配送单备注： -->
          <p>{{ $t("message.customerDeliveryNotes") }}:</p>
          <div class="client remark-box">
            <el-input type="textarea" placeholder="" v-model="detail.porder_remark.client_remark" resize="none"
              disabled>
            </el-input>
          </div>
          <!-- 客户配送单备注翻译 -->
          <p>{{ $t("message.customerDeliveryNotesTranslation") }}:</p>
          <div class="remark-box reply client">
            <el-input type="textarea" :placeholder="$t('message.customerDeliveryNotesTranslation')"
              v-model="detail.porder_remark.client_remark_translate" resize="none" :disabled="status >= 60"
              @blur="updateRemark">
            </el-input>
          </div>
          <!-- 配送依頼書管理用備考欄  -->
          <p>配送依頼書管理用備考欄 :</p>
          <div class="remark-box reply">
            <el-input type="textarea" placeholder="配送依頼書管理用備考欄" v-model="detail.porder_remark.follow_remark"
              resize="none" @blur="followRemarkEdit">
            </el-input>
          </div>
        </div>
        <!-- 附件 -->
        <div class="attachment">
          <!-- 客户添加附件： -->
          <p>{{ $t("message.customersAddAttachments") }}</p>
          <div class="attachment_list">
            <div class="row" v-for="(item, index) in detail.order_files" :key="index">
              <div class="attachment_item">
                <!-- <img src="@/assets/img/attachment.svg" alt="" /> -->
                <div class="name">
                  <el-button size="mini" :type="item.admin_id ? 'primary' : 'success'">{{ item.admin_id ?
                    item.admin.realname : '客户'
                  }}</el-button>
                  {{ item.name }}
                  <div class="time">
                    {{ item.created_at }}
                  </div>
                </div>
                <el-image style=" height: 40px; float: right; vertical-align: middle;" :src="item.file"
                  :preview-src-list="[item.file]"
                  v-if="item.file.indexOf('jpg') != -1 || item.file.indexOf('png') != -1 || item.file.indexOf('jpeg') != -1">
                </el-image>
                <a :href="item.file" download target="_blank" rel="noopener noreferrer" v-else>
                  <span>下载</span></a>
                <a href="javaScript:;" download class=" del" @click="deleteOrderFile(item.id, index)">
                  <span>删除</span></a>
              </div>
            </div>
            <!-- 进图条 -->
            <el-progress :percentage="schedule" v-if="schedule != 100"></el-progress>
          </div>
          <!-- 新增 -->
          <!-- 上传 -->
          <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
            :http-request="httpup" :before-upload="beforeAvatarUpload" multiple>
            <el-button type="primary">
              点击上传
            </el-button>
          </el-upload>
        </div>
      </div>
      <!-- 第三方仓库地址 -->
      <thirdParty ref="thirdParty" />
      <!-- 历史地址 -->
      <historicalAddresses ref="historicalAddresses" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import thirdParty from '@/components/common/thirdParty'
import { transferDate } from '@/utlis/date'
import historicalAddresses from './historicalAddresses'
export default {
  components: {
    thirdParty,
    historicalAddresses
  },
  computed: {
    ...mapState({
      receiver: (state) => state.porderDetail.receiver,
      importer: (state) => state.porderDetail.importer,
      detail: (state) => state.porderDetail.detail,
      logisticsList: (state) => state.porderDetail.logisticsList,
      status: (state) => state.porderDetail.status,
      rate: (state) => state.rate,
      boxList: (state) => state.porderDetail.boxList,
      schedule: (state) => state.schedule,
    }),
    // 标签数
    tag_num() {
      let list = this.detail.list;
      let num = 0;
      list.forEach((item) => {
        item.porder_detail_tag.forEach((items) => {
          num += items.num - 0;
        });
      });
      return num;
    },
    //匹配标签数
    match_num() {
      let list = this.detail.list;
      let num = 0;
      list.forEach((item) => {
        item.porder_detail_tag.forEach((items) => {
          num += items.match_num - 0;
        });
      });
      return num;
    },
    // 人工报价
    manualQuotation() {
      let list = [];
      let flag = false;
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          list.push(items.logistics_id);
        });
      });
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.logisticsList.length; j++) {
          if (
            list[i] == this.logisticsList[i].id &&
            this.logisticsList[i].useful_rule.is_auto_calculate == 0
          ) {
            flag = true;
            break;
          }
        }
      }
      return flag;
    },
  },
  data() {
    return {
      isImporterEdit: false,
      isReceiverEdit: false,
      importerVal: '',
      receiverVal: '',
      porder_sn: this.$route.query.porder_sn,
      addressList: [],// 收件地址列表
      Controls: this.$route.query.Controls,//无权限操作
      userRole: localStorage.getItem('japanUserRoleStatus'), //工种
      userRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo'))
    };
  },
  created() {
    if (this.userRole != 5) {
      this.userAddressList()
    }
  },
  methods: {
    addAddressSuccess(item) {
      this.receiver.zip_code = item.zip.replaceAll('〒', '')
      this.receiver.contacts = item.name
      this.receiver.address = item.address_jpn
      this.receiver.standard_no = ''
      this.receiver.address_roma = ''
      this.receiver.contacts_roma = ''
      this.receiver.standard_no = ''
      this.receiver.bank_no = ''
      this.receiver.tax_no = ''
      this.receiver.account = ''
      this.receiver.address_rome = ''
      this.receiver.company = ''
      this.receiver.company_roma = ''
      this.receiver.corporate_name = ''
      this.receiver.mobile = item.mobile
      this.receiver.name = ''
      this.receiver.name_rome = ''
      this.receiver.standard_code = ''
      this.receiver.standard_no = ''
      this.receiver.tel = ''
      this.receiver.title = ''
      this.receiver.zip = ''
      this.$forceUpdate()
      this.isReceiverEdit = !this.isReceiverEdit
    },
    // 创建配送单地址
    addAddress(type) {
      let userid = this.detail.porder_sn.split("-")[1];
      this.receiver.user_id = userid;
      this.importer.user_id = userid;
      if (type == "importer") {
        if (this.isCompanyRomaRequired(this.importer)) return false
        this.$api.porderApi.addAddress(this.importer).then((res) => {
          this.updatePorderAddress(res.data, type);
          this.importer.id = res.data;
        });
      } else {
        if (this.isCompanyRomaRequired(this.receiver)) return false
        this.$api.porderApi.addAddress(this.receiver).then((res) => {
          this.updatePorderAddress(res.data, type);
          this.receiver.id = res.data;
        });
      }
    },
    isCompanyRomaRequired(data) {
      if (data.company && (data.tax_no || data.corporate_name) && !data.company_roma) {
        this.$message.error('填写会社和法人番号时，会社名（ローマ字）必填')
        return true
      }
      return false
    },
    // 修改配送单地址
    updatePorderAddress(data, type) {
      let datas = {
        porder_sn: this.detail.porder_sn,
        receiver_address_id: "",
        importer_address_id: "",
      };
      type == "importer"
        ? (datas.importer_address_id = data)
        : (datas.receiver_address_id = data);
      this.$api.porderApi.updatePorderAddress(datas).then((res) => {
        this.$message.success(res.msg);

        type == "importer"
          ? (this.isImporterEdit = false)
          : (this.isReceiverEdit = false);
        this.checkSpecialAddress()
      });
    },
    // 检查偏远费
    checkSpecialAddress() {
      let datas = {
        porder_sn: this.porder_sn,
      };
      this.$api.porderApi.checkSpecialAddress(datas).then((res) => {
        if (res.data.is_special) {
          this.$alert(`<p style="color:red;font-size:20px">当前地址有包含偏远地区(${res.data.special_address})，目前：下面物流包含偏远收费，报价时请注意是否有偏远费用！！<br/> 
            1.KS-JP<br/> 
            2.電子特別便<br/>
            3.DQ船便<br/>
            4.TW船便<br/>
            5.OCS<br/>
            </p>`, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              let checkSpecialAddress = localStorage.getItem('checkSpecialAddress') ? JSON.parse(localStorage.getItem('checkSpecialAddress')) : []
              checkSpecialAddress.push(this.porder_sn)
              localStorage.setItem('checkSpecialAddress', JSON.stringify(checkSpecialAddress))
            }
          });
        }
      })
    },
    //修改配送单物流方式
    updatePorderLogistics() {
      let datas = {
        porder_sn: this.porder_sn,
        logistics_id: this.detail.logistics.id,
      };
      this.$api.porderApi.updatePorderLogistics(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    //编辑其他费用
    edit_other_price() {
      console.log(this.$parent.$refs.otherExpenses.dialogVisible);
      this.$parent.$refs.otherExpenses.dialogVisible = true;
    },
    //修改配送单最终打印数
    updatePorderRealTagPrint() {
      let datas = {
        porder_sn: this.porder_sn,
        fba_complete_num: this.detail.fba_complete_num
      }
      this.$api.porderApi.updatePorderRealTagPrint(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 客户-收件地址列表(客户地址模板)
    userAddressList() {
      let user_id = this.porder_sn.split('-')[1]
      this.$api.clienteleApi.userAddressList({ user_id }).then(res => {
        res.data.forEach(item => {
          item.address_roma = item.address_rome
          item.company_roma = item.company_roma || ''
          item.zip_code = item.zip
          item.standard_no = item.standard_code
          item.contacts = item.name
          item.contacts_roma = item.name_rome
          item.standard_no = item.standard_code
          item.bank_no = item.account
          item.tax_no = item.corporate_name
        })
        this.addressList = res.data
      })
    },
    //设置地址
    setAddress(e, type) {
      let itemData = this.addressList.find(item => item.id == e)
      console.log(itemData);
      for (let key in itemData) {
        if (type == 'importer') {
          this.importer[key] = itemData[key]
        } else {
          this.receiver[key] = itemData[key]
        }
      }
    },
    // 格式格式
    beforeAvatarUpload(file) {
      const isLt1000M = file.size / 1024 / 1024 < 1000;
      if (!isLt1000M) {
        this.$message.error('上传文件大小不能超过 1000MB!');
      }
      return isLt1000M;
    },
    //上传成功
    handleAvatarSuccess(res, name) {
      let datas = {
        order_sn: this.porder_sn,
        file: res.data,
        name,
        admin_id: this.userRoleInfo.id,
        created_at: transferDate(new Date()),
        admin: {
          realname: this.userRoleInfo.realname,
          id: this.userRoleInfo.id,
        }
      }
      this.$api.orderApi.storeOrderFile(datas).then(res => {
        datas.id = res.data.id
        this.detail.order_files.push(datas)
        this.$message.success(res.msg)
      })
    },
    // 删除
    deleteOrderFile(id, i) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.deleteOrderFile({ id }).then((res) => {
            this.$message.success(res.msg);
            this.detail.order_files.splice(i, 1)
          });
        })
        .catch(() => { });
    },
    //修改配送单FBA操作数
    updateFbaCompleteNum() {
      let datas = {
        porder_sn: this.porder_sn,
        fba_complete_num: this.detail.fba_complete_num
      }
      if (this.detail.fba_complete_num == 0) {
        this.$alert(`<p >确认后，实际贴标数为<span style="color:red;font-size:20px"> 0 </span> ，请确认是否更改。！<br/> 
           `, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          center: true,
          callback: action => {
            if (action == 'confirm') {
              this.$api.porderApi.updateFbaCompleteNum(datas).then(res => {
                this.$message.success(res.msg)
              })
            }
          }
        });
      } else {
        this.$api.porderApi.updateFbaCompleteNum(datas).then(res => {
          this.$message.success(res.msg)
        })
      }
    },
    //设置fba填写数
    fbaFillNum() {
      let datas = {
        porder_sn: this.porder_sn,
        fba_fill_num: this.detail.fba_fill_num
      }
      this.$api.porderApi.fbaFillNum(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.handleAvatarSuccess(data, file.file.name)
      // var client
      // let url = this.ossUp(file)
      // var _this = this;
      // // 创建 oss 阿里上传实例
      // this.$api.getUploadToken().then(async res => {
      //   // client = this.createClient(res.data)
      //   // try {
      //   //   const result = await client.multipartUpload(url, file.file, {
      //   //     progress: (p) => {
      //   //       console.log(`Progress: ${p * 100}%`);
      //   //     }
      //   //   });
      //   //   console.log('File uploaded successfully:', result);
      //   // } catch (e) {
      //   //   console.error('Error:', e);
      //   // }
      //   client = this.createClient(res.data)
      //   client.put(url, file.file).then(function (r1) {
      //     _this.handleAvatarSuccess({ data: r1.url })
      //   }).catch(function (err) {
      //     console.error('error: %j', err);
      //   });
      // })
    },
    //-修改跟进备注(与客户同步的)
    followRemarkEdit() {
      let datas = {
        porder_sn: this.porder_sn,
        follow_remark: this.detail.porder_remark.follow_remark
      }
      this.$api.porderApi.followRemarkEdit(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 更新备注
    updateRemark() {
      let datas = {
        porder_sn: this.porder_sn,
        col: ' client_remark_translate',
        value: this.detail.porder_remark.client_remark_translate
      }
      this.$api.porderApi.updateRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 历史地址
    historicalAddresses(title, type) {

      this.$refs.historicalAddresses.title = title
      this.$refs.historicalAddresses.datas = {
        type: type,
        porder_sn: this.porder_sn,
        match_porder_sn: '',
        keyword: ''
      }
      this.$refs.historicalAddresses.dialogVisible = true
      this.$refs.historicalAddresses.historyDeliveryAddressList()
    },

  },
};
</script>
<style lang="scss" scoped>
.foot {
  padding: 24px;
  margin: 24px 0;
  display: flex;

  h6 {
    border-bottom: 1px solid #edeff4;
    padding-bottom: 20px;
    margin-bottom: 16px;
    font-size: 18px;
  }

  .item {
    margin-right: 24px;
    flex: 1;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .address {
    flex: 0.8;
    padding: 24px;
    background: #f0f9eb;
    border: 1px solid #edeff4;
    border-radius: 8px;

    .row {
      line-height: 40px;
      margin-bottom: 8px;
      display: flex;

      .label {
        font-weight: 700;
        width: 150px;
      }

      .value {
        width: 288px;

        /deep/.el-textarea__inner {
          height: 50px !important;
        }

      }
    }

    .row2 {
      height: 54px;

      .domicile {
        line-height: 27px;
      }
    }
  }

  .expense {
    padding: 24px;
    background-color: #edeff4;
    border: 1px solid #edeff4;
    border-radius: 8px;
    height: 385px;
    margin-bottom: 24px;

    .row {
      display: flex;
      margin-bottom: 8px;
      line-height: 40px;

      &:nth-last-child(1) {
        margin: 0;
      }

      .label {

        font-weight: bold;
      }

      .value {
        flex: 3;
        text-align: right;
      }

      i {
        font-size: 30px;
        vertical-align: middle;
        margin-right: 20px;
        cursor: pointer;
        color: #2c96e7;
      }
    }

    .Select {
      height: 40px;
      line-height: 40px;
    }
  }

  .tag {
    padding: 24px;
    background-color: #edeff4;
    border: 1px solid #edeff4;
    border-radius: 8px;
    height: 325px;

    .row {
      display: flex;
      line-height: 40px;

      &:nth-last-child(1) {
        margin: 0;
      }

      .label {
        flex: 1.5;
        font-weight: bold;
      }

      .value {
        flex: 2;
        display: flex;

        a {
          color: #2c96e7;
          text-decoration: underline;
        }

        img {
          height: 32px;
          width: 32px;

          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }

  .remarkItem {
    flex: 0.8;
  }

  .remark {
    padding: 24px;
    background-color: #edeff4;
    border: 1px solid #edeff4;
    border-radius: 8px;
    margin-bottom: 24px;

    p {
      margin-bottom: 10px;
      font-size: 18px;
    }

    /deep/.el-textarea__inner {
      height: 100px;
      color: #222;
    }

    .client {
      margin-bottom: 10px;

      /deep/.el-textarea__inner {
        background-color: #fef0f0;
      }
    }

    .reply {
      /deep/.el-textarea__inner {
        background-color: #fff !important;
      }
    }
  }

  .attachment {
    padding: 24px;
    background-color: #edeff4;
    border: 1px solid #edeff4;
    border-radius: 8px;
    height: 285px;



    p {
      margin-bottom: 20px;
      font-size: 18px;
    }

    .attachment_list {
      height: 160px;
      overflow-y: auto;

      .attachment_item {
        flex: 1;
        display: flex;

        .name {
          flex: 10;

          .time {
            display: inline-block;
            color: #B4272D;
            margin-left: 5px;
          }
        }

        .del {
          span {
            color: #32323C;
          }

          margin-left: 10px;
        }

        .row {
          margin-bottom: 10px;
        }

        img {
          height: 32px;
          width: 32px;
          margin-right: 7px;
          vertical-align: middle;
        }

        span {
          line-height: 32px;
          color: #2c96e7;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  /deep/.el-select {
    .el-input__inner {
      background-color: #fff !important;
      color: #222;
    }
  }
}
</style>
